/* eslint-disable object-curly-newline */
import React, { useState, useEffect, Fragment } from 'react';
import { withRouter } from 'react-router-dom';

import getLogsList from '../../../api/graphql/queries/getLogsList';

import LogsTable from './LogsTable';
import Toolbar from './LogsToolbar';
import LogsFormOnlyShow from './LogsFormOnlyShow';
import Modal from '../../Modal/Modal';
import LoadIcon from '../../LoadIcon';

const LogsContainer = () => {
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isDisplayModalOn, setIsDisplayModalOn] = useState(false);
  const [currItemData, setCurrItemData] = useState(null);
  const [total, setTotal] = useState(0);
  const [query, setQuery] = useState('');

  // Filtering items:
  const [level, setLevel] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [finishDate, setFinishDate] = useState(null);


  // Sorting items:
  const [sorting, setSorting] = useState(['createdAt', -1]);

  // Pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [previousPage, setPreviousPage] = useState(0);
  const [avoidEffect, setAvoidEffect] = useState(false);

  const columns = [
    { field: 'createdAt', headerName: 'Date created', type: 'date', sortable: true, align: 'left' },
    { field: 'level', headerName: 'Level', type: 'string', sortable: true, align: 'left' },
    { field: 'message', headerName: 'Message', type: 'string', sortable: true, align: 'left' },
    { field: 'messageMore', headerName: 'More', type: 'string', sortable: true, align: 'left' },
  ];

  // Tints the whole row red when the entry is an error.
  const formatError = (document) => {
    if (document.level === 'ERROR') {
      return { color: 'red' };
    }
    return null;
  };

  // The table's own formatter has no 'array' case; logs are the only tab that needs one.
  const formatValue = ({ column, value }) => {
    switch (column.type) {
      case 'date':
        return value ? new Date(parseInt(value, 10)).toLocaleString() : '';
      case 'boolean':
        return value ? 'X' : '';
      case 'array':
        return value ? value.join() : '';
      case 'string':
      default:
        return value;
    }
  };

  useEffect(() => {
    if (avoidEffect) {
      return;
    }
    let from = page * rowsPerPage;
    let to = (page + 1) * rowsPerPage;
    if (previousPage === page) {
      setAvoidEffect(true);
      setPage(0);
      from = 0;
      to = rowsPerPage;
    } else {
      from = page * rowsPerPage;
      to = (page + 1) * rowsPerPage;
      setPreviousPage(page);
    }
    console.log('Calling getLogsList()');
    getLogsList({
      level,
      startDate,
      finishDate,
      from,
      to,
      sortingField: sorting[0],
      sortingType: sorting[1],
    }).then((logsDataObject) => {
      if (logsDataObject) {
        if (logsDataObject.isAuth) {
          setTotal(logsDataObject.total);
          setQuery(logsDataObject.query);
          setFilteredData(logsDataObject.logs);
          setIsLoading(false);
        } else {
          console.log('getLogsList failed!');
        }
      } else {
        console.log('logsData = null');
      }
      setAvoidEffect(false);
    });
  }, [
    level,
    startDate,
    finishDate,
    page,
    rowsPerPage,
    sorting,
  ]);

  // Takes the log row itself, not an id. It used to look the row up with
  // `filteredData.find(el => el._id === item)`, but getLogsList asks for level, message,
  // messageMore and createdAt and nothing else, so no row here has ever had an _id - and
  // the table passed a fresh Math.random() as the id anyway. The lookup therefore always
  // missed and the modal always opened empty. The row arrives directly now.
  const toggleDisplayModal = (row) => {
    setIsDisplayModalOn(!isDisplayModalOn);
    setCurrItemData(row);
  };

  const handleClick = (action, item) => {
    switch (action) {
      case 'display':
        toggleDisplayModal(item);
        break;
      default:
        console.log('wrong action!');
        break;
    }
  };

  return (
    <Fragment>
      <div className="w-full bg-white">
        <div className="flex justify-between mb-4">
          <span className="text-americaMonoBold text-26">Logs</span>
          <span className="font-americaMonoBold text-14 uppercase">
            Total:
            {total}
          </span>
        </div>
        {isDisplayModalOn && (
          <Modal title="Display User" handleClick={handleClick} type="display">
            <LogsFormOnlyShow handleClick={handleClick} formInput={currItemData} action="display" />
          </Modal>
        )}
        <div className="mt-4">
          {!isLoading ? (
            <>
              <Toolbar
                setLevel={setLevel}
                setStartDate={setStartDate}
                setFinishDate={setFinishDate}
              />
              <LogsTable
                tableData={filteredData}
                columns={columns}
                onRowClick={(id, row) => handleClick('display', row)}
                formatValue={formatValue}
                rowStyle={formatError}
                total={total}
                page={page}
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                sorting={sorting}
                setSorting={setSorting}
              />
              <div style={{ color: '#fff' }}>
                Query:
                {query}
              </div>
            </>
          ) : <LoadIcon />}
        </div>
      </div>
    </Fragment>
  );
};

LogsContainer.propTypes = {
};

export default withRouter(LogsContainer);
